import { render, staticRenderFns } from "./CoinNetworkDeactivationModal.vue?vue&type=template&id=48c707d6&scoped=true&"
import script from "./CoinNetworkDeactivationModal.vue?vue&type=script&lang=ts&"
export * from "./CoinNetworkDeactivationModal.vue?vue&type=script&lang=ts&"
import style0 from "./CoinNetworkDeactivationModal.vue?vue&type=style&index=0&id=48c707d6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c707d6",
  null
  
)

export default component.exports